import moment from 'moment';

export default {
  methods: {
    dateTimeIsValid(inputDate) {
      const inputTS = isNaN(inputDate) ? this.getUnixFromLocaleDate(inputDate) : inputDate;

      return moment(inputTS * 1000).isValid();
    },
    formatDateTime(date, format) {
      moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
      return moment(date).format(format || 'L LTS');
    },
  },
};
